import { render } from "./f-profile.vue?vue&type=template&id=108b1f0b&scoped=true"
import script from "./f-profile.vue?vue&type=script&lang=js"
export * from "./f-profile.vue?vue&type=script&lang=js"

import "./f-profile.vue?vue&type=style&index=0&id=108b1f0b&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108b1f0b"]])

export default __exports__